import { useLocation } from 'react-router-dom';
import { usePortfolioData } from '../../components/data/PortfolioData';
import { createPortfolioDateFormatter, resolvePortfolioTimeZone } from '../../utils/dateTime';

function resolveBuildTime() {
  const stamped = process.env.REACT_APP_BUILD_TIME;
  if (stamped) {
    const parsed = new Date(stamped);
    if (!Number.isNaN(parsed.getTime())) {
      return parsed;
    }
  }
  return new Date();
}

function LastUpdatedFooter() {
  const location = useLocation();
  const { data: portfolios } = usePortfolioData();
  const pathSegment = location.pathname.split('/').filter(Boolean)[0];
  const timeZone = resolvePortfolioTimeZone(portfolios, pathSegment);
  const dateFormatter = createPortfolioDateFormatter(timeZone);
  const buildTime = resolveBuildTime();
  const formatted = dateFormatter.formatUtc(buildTime);

  return (
    <p className="lastUpdated m-5">
      <strong>Last Deployed:</strong> {formatted}
    </p>
  );
}

export default LastUpdatedFooter;
